enum ConnectionStatus {
  PENDING = 1,
  CONNECTED = 2,
  DISCONNECTED = 3,
}

export default ConnectionStatus;
